import React, { useState, useEffect } from 'react';
import './NotificationBadge.css';

export interface NotificationData {
  id: string;
  title: string;
  body: string;
  icon?: string;
  timestamp: number;
  data?: any;
}

interface NotificationBadgeProps {
  notification: NotificationData | null;
  onClose: () => void;
  onAction?: (action: string) => void;
  autoHideDelay?: number;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  notification,
  onClose,
  onAction,
  autoHideDelay = 5000
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (notification) {
      setIsVisible(true);
      
      // Auto hide after delay
      const timer = setTimeout(() => {
        handleClose();
      }, autoHideDelay);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [notification, autoHideDelay]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300); // Wait for animation
  };

  const handleActionClick = (action: string) => {
    if (onAction) {
      onAction(action);
    }
    handleClose();
  };

  if (!notification || !isVisible) {
    return null;
  }

  return (
    <div className={`notification-badge ${isVisible ? 'show' : ''}`}>
      <div className="notification-content">
        <div className="notification-header">
          <div className="notification-icon">
            {notification.icon ? (
              <img src={notification.icon} alt="Notification" />
            ) : (
              <span className="default-icon">🔔</span>
            )}
          </div>
          <div className="notification-text">
            <h4 className="notification-title">{notification.title}</h4>
            <p className="notification-body">{notification.body}</p>
          </div>
          <button className="notification-close" onClick={handleClose}>
            ✕
          </button>
        </div>
        
        {notification.data && (
          <div className="notification-actions">
            <button 
              className="notification-action-btn primary"
              onClick={() => handleActionClick('open')}
            >
              Mở
            </button>
            <button 
              className="notification-action-btn secondary"
              onClick={() => handleActionClick('dismiss')}
            >
              Bỏ qua
            </button>
          </div>
        )}
      </div>
      
      <div className="notification-progress">
        <div 
          className="progress-bar"
          style={{ 
            animationDuration: `${autoHideDelay}ms`,
            animationPlayState: isVisible ? 'running' : 'paused'
          }}
        ></div>
      </div>
    </div>
  );
};

export default NotificationBadge;
